export default __webpack_public_path__ + "static/media/icon_elight_tube_on_30.e06027c6.png";